import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { toastIfError } from '../../../utils/toast';
import { getSelf } from '../../Self/selfEntity';
import { EmvioCheckbox, EmvioValidatedForm, EmvioValidatedButton } from '@nexio/emvio-form-components';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { historyShape } from '../../../utils/propTypes';
import './SurchargeAgreement.scss';
import { acceptSurcharge } from '../accountAgreementActions';
import { getIsSurchargeAgreementAccepted, getIsSurchargeAgreementAcceptLoading, getSurchargeAgreementError } from '../accountAgreementEntity';
import { getSelf as fetchSelf } from '../../Self/selfActions';
import { getCostSchedule } from '../../Billing/billingEntity';
import { logout } from '../../Login/loginActions';

export class SurchargeAgreement extends Component {
    static propTypes = {
        history: historyShape,
        updateUserError: PropTypes.string,
        isSurchargeAgreementAcceptLoading: PropTypes.bool,
        isUpdateUserSuccessful: PropTypes.bool,
        onToggleModal: PropTypes.func,
        onAcceptSurchargeAgreement: PropTypes.func,
        user: PropTypes.any,
        billing: PropTypes.any,
        isSurchargeAgreementAccepted: PropTypes.bool,
        surchargeAgreementError: PropTypes.string,
        onGetSelf: PropTypes.func,
        onViewSurchargeAgreement: PropTypes.func,
        onLogout: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            didAcceptTerms: false
        };

        this.submitButtonRef = React.createRef();
    }

    componentDidUpdate(prevProps) {

        toastIfError(prevProps, this.props, 'surchargeAgreementError');
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isSurchargeAgreementAccepted')) {
            toast('Surcharge Agreement Accepted Successfully.', { type: 'success' });

            this.props.onGetSelf();

            const env = process.env.BUILD_ENV;
            this.handleAcceptNonProd(env);
        }
    }

    handleAcceptNonProd = (env) => {
        if (env !== 'production') {
            this.props.history.replace('/settings/userManagement');
            //links merchants testing on sandbox to userManagement so they can see users/mids on account
        } else if (this.props.user.accountType === 'RESELLER') {
            this.props.history.replace('/home');
        } else {
            this.props.history.replace('/dashboard');
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.onAcceptSurchargeAgreement({ agreementType: 'NEXIO_SURCHARGE' });
    };

    handleAcceptSurchargeAgreement = () => {
        this.setState({ didAcceptTerms: !this.state.didAcceptTerms });
    };

    handleClick = () => {
        this.props.onLogout();
    };

    renderAgreementText = () => {
        const firstName = get(this.props.user, 'firstName');
        const lastName = get(this.props.user, 'lastName');

        /* eslint-disable @stylistic/max-len */
        return (
            <div className="agreement-text">
                <div className="agreement-section">
                    <div className="section-title">Addendum to Merchant Agreement</div>
                    <div className="sub-sections">
                        <div className="sub-section">
                            This addendum modifies the existing Merchant Agreement between Nexio/Complete Merchant Solutions (“Nexio”) and {firstName} {lastName} (“Merchant”), dated and signed {moment().format('LL')}.
                        </div>
                        <div className="sub-section">
                            Upon signing, this addendum will merge with the original Merchant Agreement between the parties.
                        </div>
                        <div className="sub-section">
                            As consideration for the indemnification set forth herein, Nexio agrees to allow Merchant to assess a surcharge fee on credit card transactions. Accordingly, Merchant agrees to indemnify Nexio to the fullest extent regarding Merchant’s failure to correctly and adequately input information into the system regarding any surcharge fees on credit card transactions.
                        </div>
                        <div className="sub-section">
                            For the above-stated purpose Merchant agrees to indemnify, defend, and hold harmless Nexio from—and against—any loss, liability, damage, penalty or expense (including attorneys’ fees, expert witness fees, and cost of defense) Nexio may suffer or incur as a result of the incorrect assessment of surcharge fees on credit card transactions resulting from Merchant entering incorrect information.
                        </div>
                        <div className="sub-section">
                            For the purpose of giving Merchant the ability to assign a surcharge to credit card transactions Nexio will provide an API endpoint which will recommend to Merchant if a transaction is eligible for a surcharge. However, the API endpoint will not enforce or ensure compliance regarding the information that is entered into the system. Merchant agrees to be responsible for ensuring that the surcharge data that it passes through Nexio’s system is correct.
                        </div>
                    </div>
                </div>
            </div>
        );
        /* eslint-enable @stylistic/max-len */
    };

    render() {
        return (
            <div className="emvio-agreement">
                <div className="agreement">
                    <div className="agreement-header">
                        Surcharge Agreement
                        <span className="logout" onClick={this.handleClick}> Logout</span>
                    </div>
                    <div className="agreement-body">
                        {this.renderAgreementText()}
                    </div>
                    <div className="agreement-footer">
                        <EmvioValidatedForm className="agreement-submit"
                            onSubmit={this.handleSubmit}
                            getButtonRef={() => this.submitButtonRef.current}
                            hasExternalErrors={(!this.state.didAcceptTerms)}
                        >
                            <div className="agree-checkbox">
                                <EmvioCheckbox
                                    validations={['required']}
                                    checked={this.state.didAcceptTerms}
                                    onChange={this.handleAcceptSurchargeAgreement}
                                />
                                <div className="label" onClick={this.handleAcceptSurchargeAgreement}>I have read and agree to the Surcharge Agreement</div>
                            </div>
                            <EmvioValidatedButton className="submit-button"
                                ref={this.submitButtonRef}
                                isLoading={this.props.isSurchargeAgreementAcceptLoading}
                            >
                                Submit
                            </EmvioValidatedButton>
                        </EmvioValidatedForm >
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isSurchargeAgreementAccepted: getIsSurchargeAgreementAccepted(state),
        surchargeAgreementError: getSurchargeAgreementError(state),
        user: getSelf(state),
        billing: getCostSchedule(state),
        isSurchargeAgreementAcceptLoading: getIsSurchargeAgreementAcceptLoading(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onAcceptSurchargeAgreement: (agreementType) => dispatch(acceptSurcharge(agreementType)),
        onGetSelf: () => dispatch(fetchSelf()),
        onLogout: () => dispatch(logout())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SurchargeAgreement));
